/**
 * System events that can be emitted by workflows
 * These events can trigger other workflows or be consumed by external systems
 */
export enum SystemEvent {
  // Email ingestion events
  EMAIL_INGESTED = "EMAIL_INGESTED",
  EMAIL_ROUTED_EMAIL_RULE = "EMAIL_ROUTED_EMAIL_RULE",
  EMAIL_ROUTED_AP_INVOICE = "EMAIL_ROUTED_AP_INVOICE",
  EMAIL_ROUTED_PURCHASE_ORDER = "EMAIL_ROUTED_PURCHASE_ORDER",
  EMAIL_ROUTED_QUOTE_SHEET = "EMAIL_ROUTED_QUOTE_SHEET",

  // AP invoice events
  AP_INVOICE_DRAFT_CREATED = "AP_INVOICE_DRAFT_CREATED",
  AP_INVOICE_PENDING_APPROVAL = "AP_INVOICE_PENDING_APPROVAL",
  AP_INVOICE_NEEDS_REVIEW = "AP_INVOICE_NEEDS_REVIEW",
}
